module.exports = __webpack_public_path__ + "static/media/6 signup.278142be.png";